module.exports = __webpack_public_path__ + "img/hr-CCM-BELT-SPRITES-SCANNER.1c8ce5e3.png";